/**
 * Removes leftover WordPress [caption]...[/caption] shortcodes from blog markup.
 */
(function () {
  function cleanHtml(html) {
    return String(html)
      .replace(/\[caption[^\]]*\]/gi, '')
      .replace(/\[\/caption\]/gi, '');
  }

  function cleanText(text) {
    return String(text)
      .replace(/\[caption[^\]]*\]/gi, '')
      .replace(/\[\/caption\]/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function run() {
    document.querySelectorAll('.article-res-content').forEach(function (el) {
      var next = cleanHtml(el.innerHTML);
      if (next !== el.innerHTML) el.innerHTML = next;
    });

    document.querySelectorAll('.card-resource__excerpt').forEach(function (el) {
      var current = el.textContent || '';
      var next = cleanText(current);
      if (next !== current.trim()) el.textContent = next;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
